import * as angular from 'angular';
import {IController} from "angular";

export class ServicesResetServicesDialogViewCtrl implements IController {
  selectedServicesIds: string[];
  resettableServices: any[];
  unResettableServices: any[];
  resetRelatedServicesChecked: boolean;
  onResettableServicesChecked: Function;
}


angular.module('bringoz.admin.deliveries')
  .component('servicesResetServicesDialogView', {
    bindings: {
      selectedServicesIds: '<?',
      resettableServices: '<?',
      unResettableServices: '<?',
      resetRelatedServicesChecked: '<?',
      onResettableServicesChecked: '&'
    },
    template: require('./services-reset-services-dialog-view.html').default,
    controller: ServicesResetServicesDialogViewCtrl
  });
